import React from "react";

function Cart(props) {
  return <div></div>;
}

export default Cart;
